<template>
  <transition name="modal">
    <div
      v-if="isVisible"
      class="modal"
      @click.self="handleOverlayClick"
    >
      <div
        v-if="shouldShowCloseButton"
        class="modal__close-button"
        @click="close"
      >
        <font-awesome-icon icon="times" />
      </div>

      <div class="modal__container">
        <header
          v-if="hasTitle"
          class="modal__header"
        >
          <h2 class="modal__title">{{ title }}</h2>
        </header>
        <div class="modal__content">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import isBlank from 'is-blank'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Modal',
  components: {
    FontAwesomeIcon
  },
  props: {
    title: {
      type: String,
      default: () => null
    },
    isVisible: {
      type: Boolean,
      default: () => false
    },
    shouldShowCloseButton: {
      type: Boolean,
      default: () => true
    },
    shouldCloseOnOverlayClick: {
      type: Boolean,
      default: () => true
    },
    shouldCloseOnEscKey: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    hasTitle () {
      return !isBlank(this.title)
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler (isVisible) {
        if (isVisible) {
          document.querySelector('html').classList.add('noscroll')
        } else {
          document.querySelector('html').classList.remove('noscroll')
        }
      }
    }
  },
  methods: {
    handleOverlayClick () {
      if (this.shouldCloseOnOverlayClick) {
        this.close()
      }
    },
    handleKeydown (e) {
      // Close on ESC
      if (this.shouldCloseOnEscKey && e.keyCode === 27) {
        this.close()
      }
    },
    close () {
      this.$emit('close')
    }
  },
  mounted () {
    this.$nextTick(() => { document.body.appendChild(this.$el) })
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

=noscroll
  overflow: hidden
  position: absolute
  touch-action: none
  width: 100vw

html.noscroll
  +noscroll
  body
    +noscroll

.modal-enter-active,
.modal-leave-active
  transition: opacity .5s

.modal-enter,
.modal-leave-to
  opacity: 0

.modal
  +z-index('modal')
  align-items: center
  backface-visibility: hidden
  background: rgba(#000, 0.9)
  bottom: 0
  display: flex
  justify-content: center
  left: 0
  padding: 10px
  position: fixed
  right: 0
  top: 0
  touch-action: none

.modal__title
  border-bottom: 1px solid $color-grey-1
  margin-top: 0
  margin-bottom: rem-calc($grid-gutter-width)
  padding-bottom: rem-calc($grid-gutter-width)

.modal__close-button
  color: $color-white
  cursor: pointer
  position: fixed
  right: rem-calc($grid-gutter-width)
  top: rem-calc($grid-gutter-width)

.modal__container
  background: $color-white
  border-radius: $border-radius
  max-height: 100%
  max-width: rem-calc(570)
  overflow: auto
  width: 100%

  +respond-min($md)
    padding: rem-calc(40)

  +respond-max($md)
    padding: rem-calc(20)
</style>



// WEBPACK FOOTER //
// src/components/ui/Modal.vue